/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  BadRequestResponse,
  ConflictResponse,
  CreateNoteBody,
  DeleteNote200,
  ForbiddenResponse,
  GetNoteHistory200,
  GetNoteImagePresignedUrl200,
  GetNoteImagePresignedUrlBody,
  GetNotes200,
  ImproveNote200,
  ImproveNoteBody,
  ImproveNotePublic200,
  ImproveNotePublic429,
  ImproveNotePublicBody,
  InternalServerErrorResponse,
  NotFoundResponse,
  Note,
  UnauthorizedResponse,
  UpdateNoteBody,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieves all notes for a case
 */
export const getNotes = (
  organizationId: string,
  projectId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetNotes200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetNotesQueryKey = (
  organizationId: string,
  projectId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes`,
  ] as const;
};

export const getGetNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotes>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotesQueryKey(organizationId, projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotes>>> = ({
    signal,
  }) => getNotes(organizationId, projectId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotes>>
>;
export type GetNotesQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetNotes<
  TData = Awaited<ReturnType<typeof getNotes>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotes>>,
          TError,
          Awaited<ReturnType<typeof getNotes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotes<
  TData = Awaited<ReturnType<typeof getNotes>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotes>>,
          TError,
          Awaited<ReturnType<typeof getNotes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotes<
  TData = Awaited<ReturnType<typeof getNotes>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all notes for a case
 */

export function useGetNotes<
  TData = Awaited<ReturnType<typeof getNotes>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNotesQueryOptions(
    organizationId,
    projectId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Creates new note
 */
export const createNote = (
  organizationId: string,
  projectId: string,
  createNoteBody: CreateNoteBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Note>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createNoteBody,
      signal,
    },
    options
  );
};

export const getCreateNoteMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNote>>,
    TError,
    { organizationId: string; projectId: string; data: CreateNoteBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNote>>,
  TError,
  { organizationId: string; projectId: string; data: CreateNoteBody },
  TContext
> => {
  const mutationKey = ["createNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNote>>,
    { organizationId: string; projectId: string; data: CreateNoteBody }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return createNote(organizationId, projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNote>>
>;
export type CreateNoteMutationBody = CreateNoteBody;
export type CreateNoteMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates new note
 */
export const useCreateNote = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createNote>>,
      TError,
      { organizationId: string; projectId: string; data: CreateNoteBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createNote>>,
  TError,
  { organizationId: string; projectId: string; data: CreateNoteBody },
  TContext
> => {
  return useMutation(getCreateNoteMutationOptions(options), queryClient);
};
/**
 * @summary Updates note content (auto-save endpoint)
 */
export const updateNote = (
  organizationId: string,
  projectId: string,
  noteId: string,
  updateNoteBody: UpdateNoteBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Note>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes/${noteId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateNoteBody,
      signal,
    },
    options
  );
};

export const getUpdateNoteMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNote>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      noteId: string;
      data: UpdateNoteBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNote>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    noteId: string;
    data: UpdateNoteBody;
  },
  TContext
> => {
  const mutationKey = ["updateNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNote>>,
    {
      organizationId: string;
      projectId: string;
      noteId: string;
      data: UpdateNoteBody;
    }
  > = (props) => {
    const { organizationId, projectId, noteId, data } = props ?? {};

    return updateNote(organizationId, projectId, noteId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNote>>
>;
export type UpdateNoteMutationBody = UpdateNoteBody;
export type UpdateNoteMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Updates note content (auto-save endpoint)
 */
export const useUpdateNote = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateNote>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        noteId: string;
        data: UpdateNoteBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateNote>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    noteId: string;
    data: UpdateNoteBody;
  },
  TContext
> => {
  return useMutation(getUpdateNoteMutationOptions(options), queryClient);
};
/**
 * @summary Deletes a note
 */
export const deleteNote = (
  organizationId: string,
  projectId: string,
  noteId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<DeleteNote200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes/${noteId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getDeleteNoteMutationOptions = <
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNote>>,
    TError,
    { organizationId: string; projectId: string; noteId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNote>>,
  TError,
  { organizationId: string; projectId: string; noteId: string },
  TContext
> => {
  const mutationKey = ["deleteNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNote>>,
    { organizationId: string; projectId: string; noteId: string }
  > = (props) => {
    const { organizationId, projectId, noteId } = props ?? {};

    return deleteNote(organizationId, projectId, noteId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNote>>
>;

export type DeleteNoteMutationError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Deletes a note
 */
export const useDeleteNote = <
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteNote>>,
      TError,
      { organizationId: string; projectId: string; noteId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteNote>>,
  TError,
  { organizationId: string; projectId: string; noteId: string },
  TContext
> => {
  return useMutation(getDeleteNoteMutationOptions(options), queryClient);
};
/**
 * @summary Get presigned URL for note image upload
 */
export const getNoteImagePresignedUrl = (
  organizationId: string,
  projectId: string,
  getNoteImagePresignedUrlBody: GetNoteImagePresignedUrlBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetNoteImagePresignedUrl200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes/images/presigned-url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getNoteImagePresignedUrlBody,
      signal,
    },
    options
  );
};

export const getGetNoteImagePresignedUrlMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getNoteImagePresignedUrl>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: GetNoteImagePresignedUrlBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getNoteImagePresignedUrl>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: GetNoteImagePresignedUrlBody;
  },
  TContext
> => {
  const mutationKey = ["getNoteImagePresignedUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getNoteImagePresignedUrl>>,
    {
      organizationId: string;
      projectId: string;
      data: GetNoteImagePresignedUrlBody;
    }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return getNoteImagePresignedUrl(
      organizationId,
      projectId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetNoteImagePresignedUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof getNoteImagePresignedUrl>>
>;
export type GetNoteImagePresignedUrlMutationBody = GetNoteImagePresignedUrlBody;
export type GetNoteImagePresignedUrlMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Get presigned URL for note image upload
 */
export const useGetNoteImagePresignedUrl = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getNoteImagePresignedUrl>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: GetNoteImagePresignedUrlBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getNoteImagePresignedUrl>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: GetNoteImagePresignedUrlBody;
  },
  TContext
> => {
  return useMutation(
    getGetNoteImagePresignedUrlMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Retrieves note version history
 */
export const getNoteHistory = (
  organizationId: string,
  projectId: string,
  noteId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetNoteHistory200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes/${noteId}/history`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetNoteHistoryQueryKey = (
  organizationId: string,
  projectId: string,
  noteId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes/${noteId}/history`,
  ] as const;
};

export const getGetNoteHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getNoteHistory>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  noteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNoteHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetNoteHistoryQueryKey(organizationId, projectId, noteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNoteHistory>>> = ({
    signal,
  }) =>
    getNoteHistory(organizationId, projectId, noteId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && noteId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNoteHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNoteHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNoteHistory>>
>;
export type GetNoteHistoryQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetNoteHistory<
  TData = Awaited<ReturnType<typeof getNoteHistory>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  noteId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNoteHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNoteHistory>>,
          TError,
          Awaited<ReturnType<typeof getNoteHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNoteHistory<
  TData = Awaited<ReturnType<typeof getNoteHistory>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  noteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNoteHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNoteHistory>>,
          TError,
          Awaited<ReturnType<typeof getNoteHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNoteHistory<
  TData = Awaited<ReturnType<typeof getNoteHistory>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  noteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNoteHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves note version history
 */

export function useGetNoteHistory<
  TData = Awaited<ReturnType<typeof getNoteHistory>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  noteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNoteHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNoteHistoryQueryOptions(
    organizationId,
    projectId,
    noteId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Takes an original note and improvement instructions, uses AI to enhance the note, and returns the improved version
 * @summary Improve note text using AI
 */
export const improveNote = (
  organizationId: string,
  improveNoteBody: ImproveNoteBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ImproveNote200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/notes/improve`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: improveNoteBody,
      signal,
    },
    options
  );
};

export const getImproveNoteMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof improveNote>>,
    TError,
    { organizationId: string; data: ImproveNoteBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof improveNote>>,
  TError,
  { organizationId: string; data: ImproveNoteBody },
  TContext
> => {
  const mutationKey = ["improveNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof improveNote>>,
    { organizationId: string; data: ImproveNoteBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return improveNote(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImproveNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof improveNote>>
>;
export type ImproveNoteMutationBody = ImproveNoteBody;
export type ImproveNoteMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Improve note text using AI
 */
export const useImproveNote = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof improveNote>>,
      TError,
      { organizationId: string; data: ImproveNoteBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof improveNote>>,
  TError,
  { organizationId: string; data: ImproveNoteBody },
  TContext
> => {
  return useMutation(getImproveNoteMutationOptions(options), queryClient);
};
/**
 * Public endpoint that takes an original note and improvement instructions, uses AI to enhance the note, and returns the improved version. This endpoint has rate limiting based on IP address and doesn't require authentication.
 * @summary Improve note text using AI (public endpoint)
 */
export const improveNotePublic = (
  improveNotePublicBody: ImproveNotePublicBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ImproveNotePublic200>(
    {
      url: `https://api.app.usesky.ai/organizations/notes/improve/public`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: improveNotePublicBody,
      signal,
    },
    options
  );
};

export const getImproveNotePublicMutationOptions = <
  TError =
    | BadRequestResponse
    | ImproveNotePublic429
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof improveNotePublic>>,
    TError,
    { data: ImproveNotePublicBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof improveNotePublic>>,
  TError,
  { data: ImproveNotePublicBody },
  TContext
> => {
  const mutationKey = ["improveNotePublic"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof improveNotePublic>>,
    { data: ImproveNotePublicBody }
  > = (props) => {
    const { data } = props ?? {};

    return improveNotePublic(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImproveNotePublicMutationResult = NonNullable<
  Awaited<ReturnType<typeof improveNotePublic>>
>;
export type ImproveNotePublicMutationBody = ImproveNotePublicBody;
export type ImproveNotePublicMutationError =
  | BadRequestResponse
  | ImproveNotePublic429
  | InternalServerErrorResponse;

/**
 * @summary Improve note text using AI (public endpoint)
 */
export const useImproveNotePublic = <
  TError =
    | BadRequestResponse
    | ImproveNotePublic429
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof improveNotePublic>>,
      TError,
      { data: ImproveNotePublicBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof improveNotePublic>>,
  TError,
  { data: ImproveNotePublicBody },
  TContext
> => {
  return useMutation(getImproveNotePublicMutationOptions(options), queryClient);
};
